import gql from "graphql-tag"
import RecognitionAutomationFragment from "../fragment/RecognitionAutomation"

export default gql`
  query RecognitionAutomations($occasionId: ID, $businessId: ID) {
    recognitionAutomations(occasionId: $occasionId, businessId: $businessId) {
      ...RecognitionAutomation
    }
  }

  ${RecognitionAutomationFragment}
`
